import { getIn } from "@utils/index"
import * as R from "ramda"
import React from "react"

// This is a workaround. Ran into issues using queries that filtered on device.type.slug

const transformData = (data, pageContext) => ({
  ...data,
  allContentfulProduct: {
    nodes: R.filter(
      ({ device }) =>
        getIn(device, "type.slug") === getIn(pageContext, "deviceTypeSlug")
    )(getIn(data, "allContentfulProduct.nodes")),
  },
  contentfulBrand: getIn(data, "contentfulBrand"),
  contentfulDeviceType: getIn(data, "contentfulDeviceType"),
})

interface PropsWithData {
  data: any
  pageContext: any
}

export default function <A extends PropsWithData>(
  WrappedComponent: React.ComponentType<A>
) {
  return (props: A) => (
    <WrappedComponent
      {...props}
      data={transformData(props.data, props.pageContext)}
    />
  )
}
